import React from 'react';

const Address = ({ address }) => {
    const dataItem = (name, prefix, postfix) => {
        let value = address[name];
        if (value) {
            value = (prefix || '') + value + (postfix || '');
        }
        return value;
    };

    return (
        <div>
            <span className="rowAddress">{dataItem('fullName', '', ',')}</span>
            <span>{dataItem('addressLine1', ' ', ',')}</span>
            <span>{dataItem('addressLine2', ' ', ',')}</span>
            <span>{dataItem('city', ' ', ',')}</span>
            <span>{dataItem('stateName', ' ', ',')}</span>
            <span>{dataItem('zipCode', ' ')}</span>
            <span>{dataItem('countryName', ' ')}</span>
        </div>
    );
};

export default Address;
